





































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import MapTab from '@/settings/MapTab.vue';
import AdminTab from '@/settings/AdminTab.vue';
import FeatureTab from '@/settings/FeatureTab.vue';
import Axios from 'axios';

@Component({
	components: {
		MapTab,
		AdminTab,
		FeatureTab,
	},
})
export default class Settings extends Vue {
	public dialog = true;
	public settings = {
		feature: {
			russia: {
				twoWeekSwitchEnabled: false,
				regimeChart: {
					title: '',
					valueYes: '',
					valueNo: '',
				},
			},
		},
		admin: {
			restrictByIpEnabled: false,
			ips: '',
			uploadOnFTP: {
				enabled: false,
				host: '',
				port: '',
				login: '',
				password: '',
				uploadPath: '',
			},
		},
		colors: {
			worldColors: {
				percentiles: '',
				nodata: '',
				default: '',
				hover: '',
				clicked: '',
				border: '',
			},
			russiaColors: {
				nodata: '',
				default: '',
				hover: '',
				clicked: '',
				border: '',
			},
		},
	};

	public created() {
		Axios.get('/api/settings/')
			.then((r) => this.settings = r.data)
			.then(() => {
				this.settings.admin.uploadOnFTP.port = this.settings.admin.uploadOnFTP.port + '';
				this.settings.feature.russia.regimeChart.valueYes = this.settings.feature.russia.regimeChart.valueYes + '';
				this.settings.feature.russia.regimeChart.valueNo = this.settings.feature.russia.regimeChart.valueNo + '';
				this.settings.admin.ips = (this.settings.admin.ips as unknown as string[]).join(',');
				this.settings.colors.worldColors.percentiles = (this.settings.colors.worldColors.percentiles as unknown as string[])
					.join(',');
			});
	}

	private closeDialog() {
		this.dialog = false;
		location.href = '/';
	}

	private save() {
		Axios.post('/api/settings/', this.settings);
	}
}
